import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setCookie } from '../actions/auth';
import { getUser } from '../actions/helpers';
import CoreSpinner from '../components/_core/CoreSpinner';

function SsoCallback() {
  const location = useLocation();

  useEffect(() => {
    async function handleSso() {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      const refresh = params.get('refresh');

      if (!token) {
        window.location.replace('/login');
        return;
      }

      // Store tokens
      setCookie('token', token);
      if (refresh) {
        sessionStorage.setItem('refreshToken', refresh);
      }
      sessionStorage.setItem('ssoUser', 'true');
      // Clear any prior account's cached identity BEFORE fetching. getUser() returns
      // the cached 'user' if present, so without this a reused browser session would
      // show the previous user (e.g. the setup account) instead of the one this token
      // belongs to. Critical: never surface a stale identity after a new sign-in.
      sessionStorage.removeItem('user');

      // Fetch user data (for THIS token) and store in sessionStorage
      const user = await getUser();
      let destination = '/login';
      if (user) {
        switch (user.role) {
          case 'superadmin':
            destination = '/companies';
            break;
          case 'admin':
            destination = '/dashboard';
            break;
          default:
            destination = '/templates';
            break;
        }
      }
      // Full page reload so AuthContext re-reads sessionStorage and
      // initializes isAuthenticated=true before rendering protected routes
      window.location.replace(destination);
    }

    handleSso();
  }, [location]);

  return <CoreSpinner loading={true} />;
}

export default SsoCallback;
